const _excluded = ["label", "children", "placement", "modifiers", "popperClassName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ButtonGroup, Popper, Grow, Paper, ClickAwayListener, MenuList } from '@material-ui/core';
import { Button } from "../Button";
import { WideArrowDownward } from "../../icons";
import { makeStyles } from '@material-ui/core/styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const useStyles = makeStyles({
  buttonGroup: {
    '& .MuiButtonGroup-groupedContainedHorizontal:not(:last-child)': {
      borderRight: '0px'
    },
    '& .MuiButtonGroup-groupedContainedHorizontal:focus-within': {
      boxShadow: 'none'
    }
  },
  toggleBtn: {
    padding: 0,
    minWidth: 32
  },
  popperZIndex: {
    zIndex: 1
  }
});
export function SplitButton(props) {
  const {
      label,
      children: _children,
      placement,
      modifiers,
      popperClassName
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const testId = props['data-testid'] || 'split-button';
  const overrides = useStyles();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ButtonGroup, {
      variant: "contained",
      ref: anchorRef,
      className: overrides.buttonGroup,
      children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
        "data-testid": "".concat(testId, "-main"),
        children: label
      })), /*#__PURE__*/_jsx(Button, {
        className: overrides.toggleBtn,
        onClick: () => setOpen(prev => !prev),
        "data-testid": "".concat(testId, "-arrow"),
        children: /*#__PURE__*/_jsx(WideArrowDownward, {})
      })]
    }), /*#__PURE__*/_jsx(Popper, {
      open: open,
      anchorEl: anchorRef.current,
      transition: true,
      disablePortal: true,
      className: popperClassName || overrides.popperZIndex,
      placement: placement,
      modifiers: modifiers,
      children: _ref => {
        let {
          TransitionProps,
          placement
        } = _ref;
        return /*#__PURE__*/_jsx(Grow, _objectSpread(_objectSpread({}, TransitionProps), {}, {
          style: {
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
          },
          children: /*#__PURE__*/_jsx(Paper, {
            children: /*#__PURE__*/_jsx(ClickAwayListener, {
              onClickAway: () => setOpen(false),
              children: /*#__PURE__*/_jsx(MenuList, {
                children: _children
              })
            })
          })
        }));
      }
    })]
  });
}